<script>
    import { onMount, createEventDispatcher } from 'svelte';
    import { getLocalStorageItem } from '../../utility.js';

    export let questions;
    export let subcategoryID;
    let answers = {};
    const dispatch = createEventDispatcher();

    function handleChoiceSelection(questionID, choice) {
        answers[questionID] = choice;
        dispatchAnswerChange();
    }

    function loadSavedAnswers() {
        const questionnaireAnswers = getLocalStorageItem('questionnaireAnswers') || {};
        answers = questionnaireAnswers[subcategoryID] || {};
        dispatchAnswerChange();
    }

    function dispatchAnswerChange() {
        dispatch('answerChange', { answers });
    }
    
    onMount(() => {
        loadSavedAnswers();
    });
</script>

{#if questions}
<div class="border border-secondary border-collapse rounded-lg">
    <table class="border-hidden table-fixed w-[100%] text-secondary-text">
        <thead class="text-xs text-secondary-text-light uppercase font-semibold">
            <th class="border border-secondary p-1 w-1/2">A</th>
            <th class="border border-secondary p-1 w-1/2">B</th>
        </thead>
        {#each questions as question, index}
            <tr class="{index % 2 === 0 ? 'bg-accent-light' : 'bg-accent-very-light'}">
                {#each JSON.parse(question.question_text.replaceAll("'", '"')) as value}
                    <td class="border border-secondary p-4 text-center cursor-pointer transition-colors hover:bg-accent {answers[question.question_id] === value ? 'bg-accent-border' : ''}" on:click={() => { handleChoiceSelection(question.question_id, value) }}>
                        <input type="radio" name={question.question_id} value={value} bind:group={answers[question.question_id]} class="text-accent-highlight bg-secondary-light border-secondary focus:ring-accent">
                        <label class="radio-label" for={question.question_id}>{value}</label>
                    </td>
                {/each}
            </tr>
        {/each}
    </table>
</div>

{:else}
    <div>Loading...</div>
{/if}
